import React, { ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { Block, Typography } from '../typography';

const onUnmountNoop = () => {};

export const ModalContextMessage = ({
  message,
  subMessage,
  onUnmount = onUnmountNoop
}: {
  message: ReactNode;
  subMessage?: ReactNode;
  onUnmount?: () => void;
}) => {
  useEffect(() => {
    return onUnmount;
  }, [onUnmount]);
  return (
    <BlockWrapper>
      <Typography size="lg" weight="bold">
        {message}
      </Typography>
      {subMessage && (
        <Typography size="md" weight="regular">
          {subMessage}
        </Typography>
      )}
    </BlockWrapper>
  );
};

const BlockWrapper = styled(Block)`
  display: flex;
  flex-direction: column;
  > * + * {
    margin-top: 0.6rem;
  }
`;
